import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-article-update',
    templateUrl: './page-article-update.component.html',
    styleUrl: './page-article-update.component.scss',
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageArticleUpdateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Update);
    }
}
